function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Icon from '../icon';
import { buildComponentName } from '../utils';
var iconMapping = {
  warning: 'exclamation_circle',
  success: 'ok_circle',
  info: 'info_circle',
  error: 'close_circle'
};
export default {
  name: buildComponentName('Alert'),
  props: {
    prefixCls: {
      type: String,
      default: 'ux-alert'
    },
    banner: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: null,
      validator: function validator(val) {
        return ['warning', 'success', 'info', 'error'].indexOf(val) > -1;
      }
    },
    closable: {
      type: Boolean,
      default: false
    },
    closeText: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    showIcon: {
      type: Boolean,
      default: null
    },
    iconType: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      closed: false
    };
  },
  computed: {
    isShowIcon: function isShowIcon() {
      var banner = this.banner,
          showIcon = this.showIcon;
      return banner && showIcon !== false ? true : showIcon;
    },
    nType: function nType() {
      var banner = this.banner,
          type = this.type;
      return banner && type === null ? 'warning' : type || 'info';
    },
    classes: function classes() {
      var _ref;

      var prefixCls = this.prefixCls,
          nType = this.nType,
          isShowIcon = this.isShowIcon,
          banner = this.banner;
      return _ref = {}, _defineProperty(_ref, prefixCls, true), _defineProperty(_ref, "".concat(prefixCls, "-").concat(nType), true), _defineProperty(_ref, "".concat(prefixCls, "-no-icon"), !isShowIcon), _defineProperty(_ref, "".concat(prefixCls, "-banner"), !!banner), _ref;
    },
    icon: function icon() {
      var type = this.type,
          iconType = this.iconType;
      var r = iconMapping.info;

      if (iconType) {
        r = iconType;
      } else if (type in iconMapping) {
        r = iconMapping[type];
      }

      return r;
    }
  },
  methods: {
    onClose: function onClose(e) {
      var alertRef = this.$refs.alertRef;
      this.closed = true;

      if (alertRef) {
        alertRef.style.height = "".concat(alertRef.getBoundingClientRect().height, "px");
      }

      this.$emit('close', e);
    },
    onAfterClose: function onAfterClose() {
      this.$emit('after-close');
    }
  },
  render: function render() {
    var h = arguments[0];
    var $slots = this.$slots,
        prefixCls = this.prefixCls,
        closed = this.closed,
        classes = this.classes,
        icon = this.icon,
        isShowIcon = this.isShowIcon,
        message = this.message,
        description = this.description,
        closeText = this.closeText,
        closable = this.closable,
        onClose = this.onClose,
        iconType = this.iconType,
        onAfterClose = this.onAfterClose;
    var desc = $slots.description || description;
    var closeIcon = $slots.closeText || closeText;
    var className = {};
    var nIcon = icon;

    if (desc) {
      className["".concat(prefixCls, "-with-description")] = true;

      if (!iconType) {
        nIcon = "".concat(nIcon, "_o");
      }
    }

    var hasClosable = closeIcon ? true : closable;
    var iconElement = isShowIcon ? h(Icon, {
      "class": "".concat(prefixCls, "-icon"),
      "attrs": {
        "type": nIcon
      }
    }) : null;
    var closeElement = hasClosable ? h("a", {
      "on": {
        "click": onClose
      },
      "class": "".concat(prefixCls, "-close-icon")
    }, [closeIcon || h(Icon, {
      "attrs": {
        "type": "close"
      }
    })]) : null;
    return h("transition", {
      "attrs": {
        "name": "".concat(prefixCls, "-slide-up")
      },
      "on": {
        "after-leave": onAfterClose
      }
    }, [closed ? null : h("div", {
      "ref": "alertRef",
      "class": [classes, className]
    }, [iconElement, h("span", {
      "class": "".concat(prefixCls, "-message")
    }, [$slots.message || message]), h("span", {
      "class": "".concat(prefixCls, "-description")
    }, [desc]), closeElement])]);
  }
};